<template>
  <b-modal
    :visible="visible"
    title="Finalizar Ocorrência"
    size="md"
    centered
    lazy
    hide-footer
    @hide="$emit('update:visible', false)"
    @show="onShow"
  >
    <div class="finalize-modal-body">
      <div class="finalize-modal-warning mb-3">
        <feather-icon icon="AlertTriangleIcon" size="18" class="mr-50" />
        Esta ação irá finalizar a ocorrência aberta. Informe o desfecho antes de confirmar.
      </div>

      <div class="form-group">
        <label><span class="required">*</span> Desfecho</label>
        <v-select
          :options="outcomes"
          :reduce="(o) => o.id"
          label="name"
          v-model="form.outcome_id"
          placeholder="Selecione o desfecho..."
          class="vselect"
          :loading="loadingOutcomes"
        />
        <small v-if="showErrors && !form.outcome_id" class="text-danger">
          Desfecho é obrigatório.
        </small>
      </div>

      <div class="form-group">
        <label>Observação</label>
        <textarea
          class="form-control"
          rows="3"
          v-model="form.outcome_observation"
          placeholder="Observação sobre a finalização (opcional)..."
          maxlength="2000"
        />
      </div>

      <OccurrenceEquipmentPanel :occurrence-id="occurrenceId" readonly />

      <div v-if="activeDispatches > 0" class="finalize-warn">
        <feather-icon icon="AlertTriangleIcon" size="14" class="mr-50" />
        {{ activeDispatches }}
        {{ activeDispatches > 1 ? "equipes serão liberadas" : "equipe será liberada" }}
        ao finalizar.
      </div>

      <div class="d-flex justify-content-end mt-1" style="gap: 8px">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$emit('update:visible', false)"
        >
          <feather-icon icon="ArrowLeftIcon" size="14" class="mr-50" />
          Voltar
        </button>
        <button type="button" class="btn btn-danger" @click="confirm">
          <feather-icon icon="CheckCircleIcon" size="14" class="mr-50" />
          Confirmar Finalização
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";
import OccurrenceEquipmentPanel from '@/components/OccurrenceEquipmentPanel.vue'

export default {
  name: "FinalizeOccurrenceModal",
  components: { vSelect, OccurrenceEquipmentPanel },

  props: {
    visible: { type: Boolean, default: false },
    disciplineId: { type: Number, default: null },
    activeDispatches: { type: Number, default: 0 },
    occurrenceId: { type: [Number, String], default: null },
  },

  data() {
    return {
      outcomes: [],
      loadingOutcomes: false,
      showErrors: false,
      form: {
        outcome_id: null,
        outcome_observation: "",
      },
    };
  },

  methods: {
    onShow() {
      this.showErrors = false;
      this.form.outcome_id = null;
      this.form.outcome_observation = "";
      this.loadOutcomes();
    },

    loadOutcomes() {
      this.loadingOutcomes = true;
      let url =
        this.$store.state.api + "outcomes/for-context?context=Ocorrencia";
      if (this.disciplineId) url += "&discipline_id=" + this.disciplineId;
      axios
        .get(url)
        .then((r) => {
          this.outcomes = r.data.data || [];
        })
        .catch(() => {})
        .finally(() => {
          this.loadingOutcomes = false;
        });
    },

    confirm() {
      this.showErrors = true;
      if (!this.form.outcome_id) return;
      this.$emit("confirm", {
        outcome_id: this.form.outcome_id,
        outcome_observation: this.form.outcome_observation || null,
      });
    },
  },
};
</script>

<style scoped>
.finalize-warn {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fdf3e4;
  color: #b45309;
  font-size: 12.5px;
}
.dark-layout .finalize-warn {
  background: #2e2214;
  color: #e5a95c;
}
.finalize-modal-warning {
  display: flex;
  align-items: flex-start;
  background: #fff8e6;
  border-left: 3px solid #ff9f43;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 0.87rem;
  color: #7d5a00;
  font-weight: 500;
  line-height: 1.5;
}

.required {
  color: #dc3545;
}
</style>
